<template>
  <div>
    <div class="sp-lb" v-for="(item, index) in cartList" :key="index">
      <div class="sp-k">
        <img :src="cartDetailList[index].img" alt="" />
        <div class="txt">{{ cartDetailList[index].name }}</div>
        <i
          v-show="showDel"
          class="del"
          @click="vodDelete(cartDetailList[index], index)"
        ></i>
      </div>
      <table>
        <thead>
          <tr>
            <th>價格</th>
            <th>數量</th>
            <th>小計</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <!-- 價格 -->
            <!-- 完整模式 -->
            <td v-if="!strBType">
              <template v-if="item.coin1 !== 'T'">
                <p>
                  {{ item.coin1 | coinName }}：${{
                    item.value1 | toThousandFilter
                  }}
                </p>
                <p>
                  {{ item.coin2 | coinName }}：${{
                    item.value2 | toThousandFilter
                  }}
                </p>
              </template>
              <template v-else>
                <strong>${{ item.value1 | toThousandFilter }}</strong>
              </template>
            </td>
            <!-- 簡易模式 -->
            <td v-else>
              <strong
                >${{
                  cartDetailList[index].direct_price | toThousandFilter
                }}</strong
              >
            </td>
            <!-- 價格 -->
            <td>
              {{ item.qty }}
            </td>
            <!-- 小計 -->
            <td v-if="!strBType">
              <template v-if="item.coin1 !== 'T'">
                <p>
                  {{ item.coin1 | coinName }}：${{
                    (item.value1 * item.qty) | toThousandFilter
                  }}
                </p>
                <p>
                  {{ item.coin2 | coinName }}：${{
                    (item.value2 * item.qty) | toThousandFilter
                  }}
                </p>
              </template>
              <template v-else>
                <strong
                  >${{ (item.value1 * item.qty) | toThousandFilter }}</strong
                >
              </template>
            </td>
            <!-- 簡易模式 -->
            <td v-else>
              <strong
                >${{
                  (cartDetailList[index].direct_price * item.qty)
                    | toThousandFilter
                }}</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pri">
      <div class="l-jg">應繳金額</div>
      <div class="r-jg" v-if="!strBType">
        <template v-if="cartTotalList.length > 0">
          <p v-for="(item, key) in cartTotalList" :key="key">
            <span v-if="item.coin !== 'T'">
              {{ item.coin | coinName }}：${{ item.value | toThousandFilter }}
            </span>
            <span v-else> ${{ item.value | toThousandFilter }} </span>
          </p>
        </template>
        <p v-else>$ 0</p>
      </div>
      <div class="r-jg" v-else>
        <template v-if="cartTotalList.length > 0">
          <p>${{ calculateCartDirectTotal() | toThousandFilter }}</p>
        </template>
        <p v-else>$ 0</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CartTable",
  props: {
    cartDetailList: Array,
    cartList: Array,
    cartTotalList: Array,
    strBType: Number,
    showDel: Boolean,
  },
  methods: {
    vodDelete(obj, key) {
      this.$snotify.confirm("是否確定刪除 " + obj.name, null, {
        buttons: [
          {
            text: "是",
            action: (obj) => {
              this.$store.dispatch("product/removeCartList", key);
              this.cartList.splice(key, 1);
              this.calculateCartTotal();
              this.$snotify.remove(obj.id);
            },
            bold: false,
          },
          {
            text: "否",
            action: (obj) => {
              this.$snotify.remove(obj.id);
            },
            bold: false,
          },
        ],
      });
    },
    calculateCartTotal() {
      this.$store.dispatch("product/calculateCartTotal", this.cartList);
    },
    calculateCartDirectTotal() {
      return this.cartDetailList.reduce(
        (obj, next, i) =>
          obj + Number(next.direct_price) * this.cartList[i].qty,
        0
      );
    },
  },
  mounted() {
    this.calculateCartTotal();
  },
};
</script>
